import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { HashLink } from 'react-router-hash-link';
import { isReferencesPageDisable } from '../config';
import './Header.css';

const Header: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    document.addEventListener('scroll', handleScroll);

    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  return (
    <Navbar
      expand="lg"
      sticky="top"
      className={scrolled ? 'navbar scrolled' : 'navbar transparent'}
    >
      <Container>
        <Navbar.Brand as={HashLink} smooth to="/#anasayfa" className="d-flex align-items-center">
          <img
            alt="Göktaş Mekanik & Doğalgaz Logo"
            src={process.env.PUBLIC_URL + '/images/mainLogo.png'}
            width="35"
            height="35"
            className="d-inline-block align-top me-2"
          />
          Göktaş Mekanik & Doğalgaz
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={HashLink} smooth to="/#anasayfa">Anasayfa</Nav.Link>
            <Nav.Link as={HashLink} smooth to="/#kurumsal">Kurumsal</Nav.Link>
            <Nav.Link as={HashLink} smooth to="/#hizmetler">Faaliyet Alanları</Nav.Link>
            <Nav.Link as={HashLink} smooth to="/#projeler">Projeler</Nav.Link>
            {!isReferencesPageDisable && <Nav.Link as={HashLink} smooth to="/#referanslar">Referanslar</Nav.Link>}
            <Nav.Link as={HashLink} smooth to="/#iletisim">İletişim</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;